import styled from '@emotion/styled';
import {mixinOverflow} from 'webapp-lib/styling';

import {StyledHeader, StyledPlaceholder} from '../Placeholder/styles';

/** @deprecated Use EList instead */
export const StyledList = styled('div', {
  shouldForwardProp: (prop) => prop !== 'as',
})`
  user-select: none;
  display: grid;
  grid-auto-rows: min-content;
  ${mixinOverflow}

  a {
    text-decoration: none;
    width: 100%;
  }

  > ${StyledPlaceholder} {
    height: 100%;
    justify-content: flex-end;
    padding-left: var(--gutter);

    ${StyledHeader} {
      font-size: var(--font-size-default);
      font-weight: var(--font-weight-title);
      text-align: center;
      margin-bottom: var(--gutter);
      margin-top: var(--gutter);
      color: var(--color-core-primary);
    }

    > svg {
      max-width: 100%;
      max-height: 100%;
      height: unset;
    }
  }
`;
